import _ from 'lodash';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/OrganizerPosterList';

const GetCompanyListReducer = handleActions({
    [Actions.getCompanyInfoRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getCompanyInfoReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        listCompany: { results: !_.isEmpty(action.payload.results) ? state.data.results.concat(action.payload.results) : action.payload.results },
        success: true,
    }),
    [Actions.getCompanyInfoReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        listCompany: { results: [] },
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getCompanyInfoClear]: () => ({
        isFetching: false,
        data: { results: [] },
        errors: {},
        listCompany: { results: [] },
        success: undefined,
    }),
}, {
    isFetching: false,
    data: { results: [] },
    errors: {},
    success: undefined,
    listCompany: { results: [] },
});

export default combineReducers({
    getList: GetCompanyListReducer,
});
